import React, { useEffect, useState } from "react";
import images from "../../../../utilities/images/images";
import "./QuestionText.css";
import ShakaSolutionViewVideoPlayer from
  "../../../../custom_utilities/shakaVideoPlayer/ShakaSolutionViewVideoPlayer";
export default function QuestionText({
  data,
  solutionOnly = false,
  language = "en",
}) {
  const optionLabels = ["A", "B", "C", "D", "E", "F"];
  const [activeTab, setActiveTab] = useState("text");
  useEffect(() => {
    setActiveTab("text");
  }, [data?.qid, data?.display_number]);

  if (!data) return null;

  const { q_text, option = [], sol_text, video_id_english, display_number } =
    data;
  const solutionVideoId =
    data?.video_id_english ??
    data?.video_id ??
    data?.videoId ??
    data?.solution_video_id ??
    null;
  const hasSolutionVideo =
    solutionVideoId !== null &&
    solutionVideoId !== undefined &&
    String(solutionVideoId).trim() !== "" &&
    String(solutionVideoId).trim() !== "0";

  const isParagraphType =
    String(data?.type || "")
      .toLowerCase()
      .includes("paragraph") ||
    String(data?.type_id || "").trim() === "4";

  const selectedParagraphText =
    language === "hi"
      ? data?.p_text_hindi ?? data?.p_text ?? data?.q_text_hindi ?? q_text
      : data?.p_text ?? data?.p_text_hindi ?? data?.q_text ?? q_text;

  const selectedQuestionText =
    language === "hi" ? data?.q_text_hindi || q_text : q_text;
  const selectedSolutionText =
    language === "hi" ? data?.sol_text_hindi || sol_text : sol_text;
  const isIntegerType = Number(data?.answer_type_id) === 3;
  const correctIntegerAnswer = String(
    data?.answer_int ?? data?.answer ?? data?.correct_answer ?? ""
  ).trim();
  const userIntegerAnswer = String(
    data?.option_int ??
      data?.integerAnswer ??
      data?.integer_Answer ??
      data?.integer_answer ??
      data?.user_option_int ??
      data?.user_answer_int ??
      data?.attempted_answer ??
      data?.answer_given ??
      ""
  ).trim();

  const directSelectedOption = data?.selectedOption ?? data?.selected_option;
  const hasExplicitSelectedOption =
    Array.isArray(directSelectedOption)
      ? directSelectedOption.length > 0
      : directSelectedOption !== null &&
        directSelectedOption !== undefined &&
        String(directSelectedOption).trim() !== "";

  const selectedOptionIds = (() => {
    const directSelected = directSelectedOption;
    if (Array.isArray(directSelected)) {
      return directSelected.map((id) => String(id));
    }
    if (
      directSelected !== null &&
      directSelected !== undefined &&
      String(directSelected).trim() !== ""
    ) {
      return [String(directSelected)];
    }

    if (Array.isArray(option)) {
      return option
        .filter((opt) => Number(opt?.is_user_correct_ans) === 1)
        .map((opt) => String(opt?.option_id));
    }

    return [];
  })();


  const computeQuestionStatus = () => {
    let userAttempted = false;
    let userSelectedCorrect = false;
    if (option && Array.isArray(option)) {
      option.forEach((opt) => {
        if (opt.is_user_correct_ans === 1) {
          userAttempted = true;
          if (opt.is_correct === 1) {
            userSelectedCorrect = true;
          }
        }
      });
    } else if (data.user_answer === "WRONG") {
      userAttempted = true;
      userSelectedCorrect = false;
    }
    if (userAttempted) {
      return userSelectedCorrect ? "correct" : "incorrect";
    }
    return "unattempted";
  };

  const questionStatus = computeQuestionStatus();

  return (
    <div className="questionText_wrapper">
      {/* Question Header */}
      {/* <div className="question_header">
        <h4>
          Q.{display_number} | {type}
        </h4>
        <div className="difficulty_tags">
          <span className="tag difficulty">{toughness}</span>
          <span className={`tag status ${questionStatus}`}>
            {questionStatus === "correct" ? (
              <>
                <img src={images.tick_icon} alt="tick" className="tick-icon" />
                Correct
              </>
            ) : questionStatus === "incorrect" ? (
              "Incorrect"
            ) : (
              "Unattempted"
            )}
          </span>
        </div>
      </div> */}

      {(!solutionOnly || isParagraphType) && (
        <>
          {/* Question HTML */}
          <div className="question_html">
            {isParagraphType && selectedParagraphText && (
              <div
                dangerouslySetInnerHTML={{ __html: selectedParagraphText }}
              />
            )}
            <div
              dangerouslySetInnerHTML={{ __html: selectedQuestionText }}
            />
          </div>

          {!solutionOnly && (
            <>
              {/* Options */}
              <div className="options_wrapper">
                {option.map((opt, index) => {
                  const isCorrect = opt.is_correct === 1;
                  const isUserAnswer = hasExplicitSelectedOption
                    ? selectedOptionIds.includes(String(opt.option_id))
                    : opt.is_user_correct_ans === 1;
                  const isUserWrong = isUserAnswer && !isCorrect;
                  const optionLabel = optionLabels[index] || String(index + 1);
                  return (
                    <div
                      key={opt.option_id}
                      className={`option ${isCorrect ? "correct" : ""} ${
                        isUserWrong ? "user-wrong" : ""
                      }`}
                    >
                      <span className="questionText_option_label">
                        {optionLabel}
                      </span>
                      <span
                        className="questionText_option_text"
                        dangerouslySetInnerHTML={{
                          __html:
                            language === "hi"
                              ? opt.option_hindi || opt.option
                              : opt.option,
                        }}
                      />
                      {isUserAnswer && (
                        <span
                          className={`your_answer_tag ${
                            isCorrect ? "correct" : "wrong"
                          }`}
                        >
                          <img
                            src={isCorrect ? images.tick_icon : images.Wrong}
                            alt={isCorrect ? "tick" : "cross"}
                            className="questionGrid-icon"
                          />
                          Your answer
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {!solutionOnly && isIntegerType && (correctIntegerAnswer || userIntegerAnswer) && (
            <div className="questionText_integer_answer_block">
              <div className="questionText_integer_answer_row">
                <span className="questionText_integer_answer_label">
                  Your answer is
                </span>
                <span className="questionText_integer_answer_value">
                  {userIntegerAnswer || "-"}
                </span>
              </div>
              <div className="questionText_integer_answer_row questionText_integer_answer_row--correct">
                <span className="questionText_integer_answer_label">
                  Correct answer is
                </span>
                <span className="questionText_integer_answer_value">
                  {correctIntegerAnswer || "-"}
                </span>
              </div>
            </div>
          )}
        </>
      )}

      {/* Solution Section */}
      <div className="solution_wrapper">
        <h5>Solution:</h5>
        <div className="solution_tabs">
          <button
            className={`tab_btn ${activeTab === "text" ? "active" : ""}`}
            onClick={() => setActiveTab("text")}
          >
            Text
          </button>
          {hasSolutionVideo && (
            <button
              className={`tab_btn ${activeTab === "video" ? "active" : ""}`}
              onClick={() => setActiveTab("video")}
            >
              Video
            </button>
          )}
        </div>
        <div className="solution_content">
          {activeTab === "text" && (
            <div
              className="solution_text"
              dangerouslySetInnerHTML={{ __html: selectedSolutionText }}
            />
          )}

          {activeTab === "video" && hasSolutionVideo && (
            <div className="solution_video">
              <ShakaSolutionViewVideoPlayer
                key={`${solutionVideoId}-${display_number}`}
                id_video={solutionVideoId}
                className="shakaPlayer"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}